import { Schema } from "@effect/schema";
import { Address } from "../address";
import { ProtocolKey } from "../protocol";
import { Percent } from "../percent";
import { Usd } from "../usd";
import { MarketAsset } from "../market-asset/market-asset";

export type SiloDataAsset = typeof SiloDataAsset.Type;
export type SiloDataAssetEncoded = typeof SiloDataAsset.Encoded;

export const SiloDataAsset = MarketAsset.pick(
  "assetKey",
  "tokenAddress",
  "rawSymbol",
  "symbol",
  "rawName",
  "name",
  "decimals",
  "isNative",
  "priceProvider",
  "maxLtv",
  "lt",

  "priceNative",
  "priceUsd",

  "liquidity",
  "utilization",

  "collateralTotal",
  "collateralBaseApr",
  "collateralRewardsApr",
  "collateralEmissionPerSecond",

  "protectedTotal",
  "protectedRewardsApr",
  "protectedEmissionPerSecond",

  "debtTotal",
  "debtBaseApr",
  "debtRewardsApr",
  "debtEmissionPerSecond",

  "tokenBalance",
  "collateralBalance",
  "protectedBalance",
  "debtBalance",
  "projectedDebtBalance"
)
  .pipe(
    Schema.extend(
      Schema.Struct({
        effectiveTokenAddress: Address,
        isCurveLpAsset: Schema.Boolean,
      })
    )
  )
  .annotations({ identifier: "SiloDataAsset" });

export type SiloData = typeof SiloData.Type;
export type SiloDataEncoded = typeof SiloData.Encoded;

export const SiloData = Schema.Struct({
  data: Schema.Struct({
    protocolKey: ProtocolKey,
    marketAddress: Address,
    routerAddress: Address,
    user: Schema.NullOr(Address),
    quotePriceUsd: Usd,
    rewardTokenPriceUsd: Usd,
    rewardTokenDecimals: Schema.Number,

    assets: Schema.Array(SiloDataAsset),

    userLtv: Percent,
    userMaxLtv: Percent,
    userLiquidationThreshold: Percent,
    hasPosition: Schema.Boolean,
  }),
}).annotations({ identifier: "SiloData" });
